import { RootState } from '@/plugins/store';
import { GetterTree } from 'vuex';
import { SuiviFacturesEnRetardState } from '.';

export const getters: GetterTree<SuiviFacturesEnRetardState, RootState> = {
    getSuiviFacturesEnRetardScroll(state) {
        return state.scroll;
    },
    getSuiviFacturesEnRetardItems(state) {
        return state.facturesEnRetard;
    },
    getSuiviFacturesEnRetardIsLoading(state) {
        return state.isLoading;
    },
    getSuiviFacturesEnRetardPage(state) {
        return state.page;
    },
    getSuiviFacturesEnRetardNbOfPages(state) {
        return state.nbOfPages;
    },
    getSuiviFacturesEnRetardSort(state) {
        return state.sort;
    },
    getSuiviFacturesEnRetardCount(state) {
        return state.count;
    },
};